<div>
    <app-audi-text variant="order4" className="audi-type-normal" weight="bold" text="Vehicle and Current Plan Details"></app-audi-text>
    <br /><br />

    <div class="column__list">
        <div class="card__list">
            <app-audi-text-input inputId="select-plan-vehicleModel" label="Vehicle Model" value="{{selectedVehicleDetail?.modelDescription}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="select-plan-year" label="Model Year" value="{{selectedVehicleDetail?.year}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="select-plan-odometerReading" label="Odometer Reading" value="{{selectedVehicleDetail?.currentOdometer}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="select-plan-currentPlanType" label="Current Plan Type" value="{{selectedVehicleDetail?.planType}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <div [hidden]="isPlanTypeUnknown">
                <app-audi-text-input inputId="select-plan-currentPlanYears" label="Current Plan Years" value="{{selectedVehicleDetail?.currentPlanYears}}" isRequired="true"
                    disabled=true>
                </app-audi-text-input>
            </div>
        </div>
        <div class="card__list">
            <div [hidden]="isPlanTypeUnknown">
                <app-audi-text-input inputId="select-plan-currentPlanDistance" label="Current Plan Distance" value="{{selectedVehicleDetail?.currentPlanEndKM}}" isRequired="true"
                    disabled=true>
                </app-audi-text-input>
            </div>
        </div>
        <div [hidden]="justBrowsing">
            <div class="card__list">
                <app-audi-text-input inputId="select-plan-warrantyStatus" label="Warranty" value="{{selectedVehicleDetail?.warrantyStatus}}" isRequired="true" disabled="true">
                </app-audi-text-input>
            </div>
        </div>
    </div>

    <div [hidden]="!isPlanTypeUnknown" class="standardPlanText">
        <app-audi-text text="The Standard Plan of this Vehicle has been assumed" variant="copy1"></app-audi-text><br /><br />
    </div>

    <app-audi-text variant="order4" className="audi-type-normal" weight="bold" text="Recommended New Plan Options"></app-audi-text>
    <br /><br />

    <div class="column__list">
        <div class="card__list" *ngFor="let npo of newPlanOptions">
            <app-new-plan-option [data]="npo"></app-new-plan-option>
        </div>
    </div>
    <div [hidden]="newPlanOptions?.length>0">
        <app-audi-text text="We couldn't find any recommended plans for your vehicle." variant="copy1">
        </app-audi-text>
        <br /><br />
    </div>

    <app-customize-plan #customizePlan></app-customize-plan>

    <app-audi-text variant="order4" className="audi-type-normal" weight="bold" text="Freeway Plan Types"></app-audi-text>
    <br /><br />

    <div class="column__list">
        <div class="card__list" style="border-bottom:1.5px solid #000000;height:100%;">
            <div>
                <app-audi-text text="Warranty Plan" variant="copy1" weight="bold"></app-audi-text> <br /><br />
                <app-audi-text text="{{contentTexts | ContentText:'WarrantyPlanDetails'}}" variant="copy1">
                </app-audi-text>
            </div>
        </div>
        <div class="card__list" style="border-bottom:1.5px solid #000000;height:100%;">
            <div>
                <app-audi-text text="Freeway Service Plan" variant="copy1" weight="bold"></app-audi-text> <br /><br />
                <app-audi-text text="{{contentTexts | ContentText:'ServicePlanDetails'}}" variant="copy1">
                </app-audi-text>
            </div>
        </div>
        <div class="card__list" style="border-bottom:1.5px solid #000000;height:100%;">
            <div>
                <app-audi-text text="Freeway Maintenance Plan" variant="copy1" weight="bold"></app-audi-text> <br /><br />
                <app-audi-text text="{{contentTexts | ContentText:'MaintenancePlanDetails'}}" variant="copy1">
                </app-audi-text>
            </div>
        </div>
    </div>

    <div *ngIf="justBrowsing">
        <br /><br />
        <app-audi-text text="{{contentTexts | ContentText:'Disclaimer'}}" variant="copy1">
        </app-audi-text>
        <br /><br />
    </div>

    <br />
    <app-audi-button text="Back" (click)="onBackToCustomerDetails()" variant="secondary"></app-audi-button>
</div>